<template ref="addItemImage">
  <div class="zujian">
    <div class="">
      <span class="">封面图：</span>
      <upload-thumb v-model="thumbUrl"
                    ref="uploadthumb"
                    :defaultList="thumblist"
                    :autoCropWidth="670"
                    :autoCropHeight="385"
                    :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:670*385,大小不超过2M'"
                    :maxNum="1"></upload-thumb>
    </div>
    <div class="">
      <span class="">链接类型：</span>
      <Select v-model="link_type"
              style="width:200px">
        <Option value="1">H5</Option>
        <Option value="2">定制</Option>
        <Option value="3">盲盒</Option>
        <Option value="4">商城</Option>
        <Option value="5">非遗地图</Option>
      </Select>
    </div>
    <div class=""
         style="margin-top:10px;">
      <span class="">链接地址：</span>
      <Input v-model="linkUrl"
             placeholder="请输入..."
             style="width: 300px" />
    </div>
    <div class="drawer-footer">
      <Button style="margin-right: 8px"
              @click="cancleFun">取消</Button>
      <Button type="primary"
              @click="activityAdd">确定</Button>
    </div>
  </div>

</template>
<script>
import UploadThumb from "../../common/thumb";
export default {
  name: "",
  data () {
    return {
      thumbUrl: "",
      thumblist: [],
      link_type: null, // 链接类型
      linkUrl: "", // 链接
      is_edit: false
    }
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  components: {
    UploadThumb
  },
  created: function () {

  },
  methods: {
    // 初始化
    initFun () {
      this.thumbUrl = "";
      this.thumblist = [];
      this.linkUrl = "";
      this.is_edit = "";
      this.link_type = null;
    },
    // 取消
    cancleFun () {
      this.$emit("showItemImage", -1);
    },
    // 编辑
    detailFun (params) {
      console.log("编辑", params);
      this.is_edit = true;
      let content = params;
      if (content.thumb) {
        this.thumblist = [{
          url: content.thumb,
          status: "finished"
        }]
      };
      this.typeId = content.typeId;
      this.linkUrl = content.link;
      this.link_type = content.link_type;
    },
    // 确定
    activityAdd () {
      let imageList = this.$refs['uploadthumb'].uploadList;
      console.log("确定====")
      if (imageList.length == 0) {
        this.$Message.warning("请上传图片！");
        return;
      }
      let params = {
        thumb: imageList[0].url,
        link: this.linkUrl,
        link_type: this.link_type
      };
      this.$emit("updateList", this.is_edit, params);
    }
  }
}
</script>
<style>
.zujian img {
  max-width: 100%;
  display: block;
}
.typecontent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10002;
}
.drawer-footer {
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>